import React from 'react'
export default function MinusIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 2">
            <path fillRule="evenodd" d="M.4 0h18v2H.4V0Z" clipRule="evenodd"/>
        </svg>
    )
}